import React from 'react';
import './index.less';
import { Radio } from 'antd';
import classNames from 'classnames';

export interface IABSRadioProps {
  style?: React.CSSProperties;
  className?: string;
  content: string;
  value: string;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (e: any) => void;
  removeMarginRight?: boolean;
}

class ABSRadio extends React.Component<IABSRadioProps> {
  static defaultProps = {
    removeMarginRight: false
  };

  render() {
    const { style, className, content, value, disabled, checked, onChange, removeMarginRight } = this.props;
    const classs = classNames(className, {'remove-margin-right': removeMarginRight });
    return (
      <div className="abs-radio">
        <Radio style={style} 
          value={value} 
          disabled={disabled} 
          checked={checked} 
          className={classs} 
          onChange={onChange}>
          <span className="abs-radio-text">{content}</span>
        </Radio>
      </div>
    );
  }
}

export default ABSRadio;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSRadio/index.tsx